<div class="thumbnail-section" [ngClass]="{'give-side-padding': giveSidePadding}">
  @for (item of thumbnailData; track item) {
    <div class="thumb-item">
      <div class="thumb-item-image img-rounded">
        <img [src]="item.image" />
      </div>
      <h4 class="thumb-item-title">{{ item.title }}</h4>
      <p class="thumb-item-text">{{ item.text }}</p>
    </div>
  }
</div>